module.exports = __webpack_public_path__ + "img/Group_2@2x.ccd97f88.png";